import * as React from 'react';
import forbidden from './images/forbidden@2x.png';
import { ForbiddenPage, Header, ImageContainer, Subtext, TextContainer } from './styles/ForbiddenStyles';

const Forbidden = (): JSX.Element => {
  return (
    <ForbiddenPage>
      <TextContainer>
        <Header>No Permission</Header>
        <Subtext>Seems like you don't have permission for this site</Subtext>
      </TextContainer>
      <ImageContainer>
        <img src={forbidden} alt='forbidden' />
      </ImageContainer>
    </ForbiddenPage>
  );
};

export default Forbidden;
